import { datadogRum } from '@datadog/browser-rum';
import { settings } from '../config/app-settings';

function shouldEnableTelemetry() {
  const env = import.meta.env.VITE_NODE_ENV ?? 'development';
  return env === 'production' || env === 'staging' || env === 'qa';
}

function initTelemetry() {
  if (!shouldEnableTelemetry()) {
    return;
  }
  datadogRum.init({
    applicationId: '7528922e-db79-4415-b13b-3630b84630e3',
    clientToken: 'pub66846f50a9ba780b8eee76bf6d38e938',
    site: 'us5.datadoghq.com',
    service: 'pulse-employee-survey',
    env: import.meta.env.VITE_NODE_ENV,
    version: settings.datadogVersion,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.startSessionReplayRecording();
}

export { initTelemetry };
